import { render, staticRenderFns } from "./ShippingList.html?vue&type=template&id=48781614&external"
import script from "./ShippingList.ts?vue&type=script&lang=ts&external"
export * from "./ShippingList.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports